import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PanelComponent } from '../panel/panel.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'webmodule-order-panel-base',
  templateUrl: './panel-base.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PanelComponent, TranslatePipe],
  standalone: true,
})
export class PanelBaseComponent {}
